export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const GOAL_LABELS = { weight_loss: "Weight loss", weight_gain: "Weight gain", fitness: "Fitness & energy", not_sure: "Not sure yet" };
export const STATUS_LABELS = { new: "New", contacted: "Contacted", converted: "Converted" };
